/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  UserListsService,
  IUserListsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IInviteUserMethods,
  InviteUserService,
  PresentationListsService,
  IPresentationListsMethods,
  ISendPurchaseInviteMethods,
  SendPurchaseInviteUserService,
  ISearchEmailMethods,
  SearchEmailService,
  AdminPresentationListsService,
  IAdminPresentationListsMethods,
  IMyCommitteInviteStatusMethods,
  MyCommitteInviteStatusService,
  ICheckCountInviteMethods,
  CheckCountInviteService,
  InviteTableService,
  IInviteTableMethods,
  CommitteListService,
  ICommitteListMethods,
  ISendSinglePurchaseInviteMethods,
  SendSinglePurchaseInviteUserService,
  IUserListsWithBoxesMethods,
  UserListsWithBoxesService,
  IRecallInviteMethods,
  RecallInviteUserService
} from "./components";

export type UsersListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IRecallInviteMethods &
  IUserListsMethods &
  IPresentationListsMethods &
  ISendPurchaseInviteMethods &
  ISearchEmailMethods &
  IMyCommitteInviteStatusMethods &
  IAdminPresentationListsMethods &
  IInviteTableMethods &
  ICommitteListMethods &
  ISendSinglePurchaseInviteMethods &
  IUserListsWithBoxesMethods &
  ICheckCountInviteMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new UserListsService(),
    new InviteUserService(),
    new RecallInviteUserService(),
    new PresentationListsService(),
    new SendPurchaseInviteUserService(),
    new SearchEmailService(),
    new MyCommitteInviteStatusService(),
    new AdminPresentationListsService(),
    new CheckCountInviteService(),
    new InviteTableService(),
    new CommitteListService(),
    new UserListsWithBoxesService(),
    new SendSinglePurchaseInviteUserService(),
  ];
};

export const getAgent = () => {
  return createAgent<UsersListPageAgent>({
    plugins: getPlugins(),
  });
};
